import { render, staticRenderFns } from "./VersionsToolbar.vue?vue&type=template&id=1c78f950&scoped=true"
import script from "./VersionsToolbar.vue?vue&type=script&lang=js"
export * from "./VersionsToolbar.vue?vue&type=script&lang=js"
import style0 from "./VersionsToolbar.vue?vue&type=style&index=0&id=1c78f950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c78f950",
  null
  
)

export default component.exports